import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ColorPickerViewModelType from '@/ViewModels/Controls/ColorPickerViewModel';
import ResourceManager from '@/Management/ResourceManager';
import LocatorHelper from '@/Utility/LocatorHelper';

export default class ColorPicker extends Control {

    private jQueryControl: JQuery;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.ColorPickerExt>;

    public constructor(private viewModel: ColorPickerViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><input></div>');

        this.applyBindings(this.jQueryControl.find('input'), {
            kendoColorPicker: {
                value: this.viewModel.color,

                enabled: this.viewModel.isEnabled,

                messages: {
                    apply: ResourceManager.getInstance().loadResource('APPLY'),
                    cancel: ResourceManager.getInstance().loadResource('CANCEL')
                },

                palette: null,

                widget: this.widget
            }
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: kendo.ui.ColorPickerExt): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'colorpicker',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        this.applyBindings(widget._getPopup().element, {
            controlName: 'colorpicker-container',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        // Locator
        let clickableDiv = this.jQueryControl.find('span.k-selected-color');
        let popup = $(widget._getPopup().element);
        let textbox = popup.find('input.k-color-value');
        let btnOK = popup.find('button.apply');
        let btnCancel = popup.find('button.cancel');

        this.applyBindings(this.jQueryControl, {
            locator: this.viewModel.locator
        });
        this.applyBindings(popup, {
            locator: LocatorHelper.buildLocator(this.viewModel.locator, "popup")
        });
        this.applyBindings(clickableDiv, {
            locator: LocatorHelper.buildLocator(this.viewModel.locator, "select")
        });
        this.applyBindings(textbox, {
            locator: LocatorHelper.buildLocator(this.viewModel.locator, "value")
        });
        this.applyBindings(btnOK, {
            locator: LocatorHelper.buildLocator(this.viewModel.locator, "apply")
        });
        this.applyBindings(btnCancel, {
            locator: LocatorHelper.buildLocator(this.viewModel.locator, "cancel")
        });
    }

    public addLabelReference(label: JQuery): JQuery {
        let id = this.identifier + '-input';
        this.getControl().find('input').attr('id', id);
        label.attr('for', id);
        return label;
    }
}

ComponentManager.setControl('ColorPicker', ColorPicker, 'RADPresentation.HTMLClient.DefaultViewExtensions');